<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<!-- <breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" /> -->

		<main-content
			:title="page.title || page.header"
			:subtitle="page.subtitle"
			:content="page.content"
			:introduction-content="page.introductionContent"
		>
			<section class="main-content">
				<div class="row justify-left">
					<div class="columns column12">
						<recursive-sitemap :items="sitemap" />
					</div>
				</div>
			</section>
		</main-content>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: sitemap } = await useWebsiteFetch('sitemap', {
	query: { language: locale.value },
	key: `${locale.value}/sitemap`,
});
</script>
